import React, { useState } from "react";
import "./agendamento.css";
import ListaAgendados from "./Lista-de-Agendamentos/listaAgendados";
import { Agendamento } from "../../../API/AgendarEvento";

function TelaTemporizacao() {
  const [grupoLuz, setGrupoLuz] = useState("Postes");
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState("ON");
  const [offValueLuz, setOffValueLuz] = useState("OFF");

  const [grupoExaustor, setGrupoExaustor] = useState("Exaustor 1 e 2");
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState("ON");
  const [offValueExaustor, setOffValueExaustor] = useState("OFF");

  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleSelectChange = (e, setGrupo, setOnValue, setOffValue) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setGrupo(e.target.value);
    setOnValue(selectedOption.getAttribute('on'));
    setOffValue(selectedOption.getAttribute('off'));
  };

  const temporizar = async () => {
    if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      alert("Preencha todos os campos.");
      return;
    } else if (grupoLuz !== "" && inicioLuz !== "" && fimLuz !== "" && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento apenas de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
    } else if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && grupoExaustor !== "" && inicioExaustor !== "" && fimExaustor !== "") {
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    } else {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
  
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      alert("Agendamento de exaustores salvo.");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    }
    // Alterna o valor de refreshFlag para forçar a re-renderização de ListaAgendados
    setRefreshFlag(!refreshFlag);
  };

  return (
    <div id="TelaTemporizacao-mobile">
      <div id="temporizacao-mobile">
        <h1>Agendamentos diários</h1>
        <div id="temporizacaoContent-mobile">
          <div id="temporizacaoContent1-mobile">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1-mobile">
              Grupo
              <select id="selectGrupoLuz-mobile" onChange={(e) => handleSelectChange(e, setGrupoLuz, setOnValueLuz, setOffValueLuz)}>
              <option value="Postes" on="1A10" off="1A00">
                  Postes
                </option>
                <option value="Degraus / Portíco" on="1B10" off="1B00">
                  Degraus / Portíco
                </option>
                <option value="Espetos" on="1C10" off="1C00">
                  Espetos
                </option>
                <option value="Arandelas Veículos" on="1D10" off="1D00">
                  Arandelas Veículos
                </option>
                <option value="Varandas Gourmet" on="1E10" off="1E00">
                  Varandas Gourmet
                </option>
                <option value="Tomadas Gourmet" on="1F10" off="1F00">
                  Tomadas Gourmet
                </option>
                <option value="SPA" on="1G10" off="1G00">
                  SPA
                </option>
                <option value="Hall Entrada" on="1H10" off="1H00">
                  Hall Entrada
                </option>
                <option value="Circulação" on="1I10" off="1I00">
                  Circulação
                </option>
                <option value="Varanda Teen Lounge" on="1J10" off="1J00">
                  Varanda Teen Lounge
                </option>
                <option value="Varanda Sport Bar" on="1K10" off="1K00">
                  Varanda Sport Bar
                </option>
                <option value="Tomadas Sport Bar" on="1L10" off="1L00">
                  Tomadas Sport Bar
                </option>
                <option value="Arandelas" on="1M10" off="1M00">
                  Arandelas
                </option>
                <option value="Postes Lazer" on="1N10" off="1N00">
                  Postes Lazer
                </option>
                <option value="Floreira Degraus" on="1P10" off="1P00">
                  Floreira Degraus
                </option>
                <option value="Piscina Subaquático" on="1Q10" off="1Q00">
                  Piscina Subaquático
                </option>
                <option value="Floreira Piscina" on="1R10" off="1R00">
                  Floreira Piscina
                </option>
                <option value="Arandelas Piscina" on="1T10" off="1T00">
                  Arandelas Piscina
                </option>
                <option value="Floreiras Quadra" on="1U10" off="1U00">
                Floreiras Quadra
                </option>
                <option value="Quadra de tênis" on="1V10" off="1V00">
                  Quadra de tênis
                </option>
                <option value="Quadra Poliesportiva" on="1W10" off="1W00">
                  Quadra Poliesportiva
                </option>
                <option value="Quadra Beach Tennis" on="1X10" off="1X00">
                  Quadra Beach Tennis
                </option>
                <option value="Tomadas Goumert Lazer" on="1X10" off="1X00">
                  Tomadas Goumert Lazer
                </option>
                <option value="Circulação Térreo" on="1Z10" off="1Z00">
                  Circulação Térreo
                </option>
                <option value="Cervejeira Salão de Festas" on="1[10" off="1[00">
                  Cervejeira Salão de Festas
                </option>
                <option value="Rota de Fuga" on="1\\00" off="1\\00">
                  Rota de Fuga
                </option>
              </select>
              <label htmlFor="temporizacao1-mobile">Inicio</label>
              <input type="time" id="inicioLuz" name="temporizacao1" value={inicioLuz} onChange={(e) => setInicioLuz(e.target.value)} />
              <label htmlFor="temporizacao2-mobile">Fim</label>
              <input type="time" id="fimLuz" name="temporizacao2" value={fimLuz} onChange={(e) => setFimLuz(e.target.value)} />
            </div>
          </div>
          <div id="temporizacaoContent2-mobile">
            <h2>Exaustor</h2>
            <div id="temporizacaoContent2-1-mobile">
              Grupo
              <select id="selectGrupoExaustores-mobile" onChange={(e) => handleSelectChange(e, setGrupoExaustor, setOnValueExaustor, setOffValueExaustor)}>
                <option value="Exaustor 1 e 2" on="ON" off="OFF">
                  Exaustor 1 e 2
                </option>
                <option value="Exaustor 3 e 4" on="ON" off="OFF">
                  Exaustor 3 e 4
                </option>
                {/* Outras opções */}
              </select>
              <label htmlFor="temporizacao4-mobile">Inicio</label>
              <input type="time" id="inicioExaustor" name="temporizacao3" value={inicioExaustor} onChange={(e) => setInicioExaustor(e.target.value)} />
              <label htmlFor="temporizacao2-mobile">Fim</label>
              <input type="time" id="fimExaustor" name="temporizacao4" value={fimExaustor} onChange={(e) => setFimExaustor(e.target.value)} />
            </div>
          </div>
        </div>
        <button id="btnSalvar-mobile" onClick={temporizar}>
          Salvar
        </button>
      </div>
      <div id="Lista-agendados-mobile">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;